// extracted by mini-css-extract-plugin
module.exports = {"userAvatar":"_17LQu","companyAvatar":"_1JYip","userItemWrapper":"oB7ho"};